import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppBaseService } from './app-base.service';
import { configConst, userData } from '../const-jsons/config-details';
import { Observable,of, Subject } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { UserCustomerInputModel, IntegerModel, PasswordChangeModel, ResetPasswordSuccessModel } from '../../shared/model/index'
import { ConfigurationModel, LoginUserModel, UserDetailsModel, InputConfigModel } from '../model';
import { CustomAlertModel } from '../model/custom-alert.model';
import { ConfirmService } from './confirm.service';
@Injectable({
  providedIn: 'root'
})
export class UserSharedService {

    userDetails: LoginUserModel=null;
    configDetails: ConfigurationModel = new ConfigurationModel();
    apiRequestCount: number = 0;
    cookies = {
        userId: 'idpUser'
    };
    customMessageConfig: CustomAlertModel[] = [];
    // Observable navItem source
    private customClickSub = new Subject<any>();
    // Observable navItem stream
    public customClickObj$ = this.customClickSub.asObservable();
    constructor(public _base: AppBaseService, public _http: HttpClient, public _cofirmService: ConfirmService) { }

  //postLogin(login:LoginUserModel){
  //  return new Observable((observer) => {
    
  //    // observable execution
  //    observer.next(userData.find(x => x.email === login.email))
  //    observer.complete()
  //  });
  //}

  setConfiguration(url:string){
    return new Observable((observer) => {
    
      // observable execution
      observer.next(configConst.find(x => x.url === url))
      observer.complete()
    });
      
  }

    public AuthenticateUser(obj: LoginUserModel): Observable<LoginUserModel> {
        // let configDetails = new ConfigurationModel();
        let url = this._base.appVar.apiUrl + '/Account/Authenticate';
       
        return this._http.post(url, obj)
            .pipe(map((response: LoginUserModel) => {

                this.userDetails = response;
                return this.userDetails;
            })
            //    , catchError(this._base.handleError)
            );
    }

    public GetUserDetail(obj: LoginUserModel): Observable<LoginUserModel> {
        if (this.userDetails) {
            return of(this.userDetails);
        }
        else {

            // let configDetails = new ConfigurationModel();
            let url = this._base.appVar.apiUrl + '/Account/GetUserDetail';

            return this._http.post(url, obj)
                .pipe(map((response: LoginUserModel) => {

                    this.userDetails = response;
                    return this.userDetails;
                })
                    , catchError(this._base.handleError));
        }
    }

    public GetUserDetailforManagePassword(obj: LoginUserModel): Observable<LoginUserModel> {
        //if (this.userDetails) {
        //    return of(this.userDetails);
        //}
        //else {

            // let configDetails = new ConfigurationModel();
            let url = this._base.appVar.apiUrl + '/ManageUser/GetUserDetail';

            return this._http.post(url, obj)
                .pipe(map((response: LoginUserModel) => {

                   // this.userDetails = response;
                    return response;
                })
                    , catchError(this._base.handleError));
       // }
    }

    

    public SPInitiateSSO(obj: InputConfigModel): Observable<void> {
        
        // let configDetails = new ConfigurationModel();
        let url = this._base.appVar.apiUrl + '/Home/SPInitiateSSO';
        return this._http.post<void>(url, obj);
    }

    public ForgotPasswordClick(obj: UserCustomerInputModel): Observable<IntegerModel> {
        // let configDetails = new ConfigurationModel();
        let url = this._base.appVar.apiUrl + '/ManageUser/ForgotPassword';

        return this._http.post(url, obj)
            .pipe(map((response: IntegerModel) => {

                //this.userDetails = response;
                //return this.userDetails;
                return response;
            })
                , catchError(this._base.handleError));
    }

    public VerifyResetPasswordCode(id: string): Observable<IntegerModel> {
        // let configDetails = new ConfigurationModel();
        let url = this._base.appVar.apiUrl + '/ManageUser/VerifyResetPasswordCode';
        var request = { VerificationCode: id}
        return this._http.post(url, request)
            .pipe(map((response: IntegerModel) => {

                //this.userDetails = response;
                //return this.userDetails;
                return response;
            })
                , catchError(this._base.handleError));
    }

    public ResetUserPassword(obj: PasswordChangeModel): Observable<ResetPasswordSuccessModel> {
        // let configDetails = new ConfigurationModel();
        let url = this._base.appVar.apiUrl + '/ManageUser/ResetUserPassword';
        var request = {
            VerificationCode: obj.verificationCode,
            NewPassword: obj.newPassword
        }
        return this._http.post(url, request)
            .pipe(map((response: ResetPasswordSuccessModel) => {
                return response;
            })
                , catchError(this._base.handleError));
    }


    public ChangeUserPassword(obj: PasswordChangeModel): Observable<IntegerModel> {
        // let configDetails = new ConfigurationModel();
        let url = this._base.appVar.apiUrl + '/ManageUser/ChangeUserPassword';
        var request = {
            UserID: obj.userId,
            NewPassword: obj.newPassword,
            OldPassword: obj.oldPassword,
            customerId: obj.customerId
        }
        return this._http.post(url, request)
            .pipe(map((response: IntegerModel) => {
                return response;
            })
                , catchError(this._base.handleError));
    }



    public SetCustomMessage(messageObj: CustomAlertModel) {


        this.customMessageConfig = [];
        this.customMessageConfig.push(messageObj);
        setTimeout(() => {
            if (this.customMessageConfig.length)
                this.customMessageConfig.splice(0, 1);

        }, messageObj.timeOut);


    }

    public setCustomclickStream() {
        this.customClickSub.next(this.customMessageConfig[0].data)
    }


}
